<template>
  <el-form-item label="onSubFormRowDelete" label-width="150px">
    <el-button type="info" icon="el-icon-edit" plain round :class="[eventHandled ? 'button-text-highlight' : '']" @click="editEventHandler('onSubFormRowDelete', eventParams)">
      {{ i18nt('designer.setting.addEventHandler') }}</el-button
    >
  </el-form-item>
</template>

<script>
import { reactive, toRefs } from 'vue';
import { useI18n } from '@/utils/i18n';
import { useEventMixin } from './eventMixin';

export default {
  name: 'onSubFormRowDelete-editor',
  props: {
    designer: Object,
    eventHandled: {
      default: false,
      type: Boolean,
    },
    optionModel: Object,
    selectedWidget: Object,
  },
  setup(props) {
    const { i18nt } = useI18n();
    const eventMixin = useEventMixin();

    const data = reactive({
      eventParams: ['subFormData', 'deletedDataRow', 'deletedRowIndex'],
    });
    return {
      i18nt,
      ...toRefs(props),
      ...toRefs(data),
      ...eventMixin,
    };
  },
};
</script>

<style scoped></style>
